module.exports = __webpack_public_path__ + "static/media/QuickBooks-Online-Second-Image.aefea024.jpg";